import classNames from 'classnames';
import * as React from 'react';
import {useState} from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {animated, config, Spring} from 'react-spring';

import styles from './RefreshButton.less';
import {TranslateUtils} from 'src/js/common/utils';

const I18N = defineMessages({
  REFRESH: {
    id: 'common.refreshButton.refresh',
    defaultMessage: 'Refresh',
    description: 'title text for refresh button',
  },
});

interface OwnProps {
  onClick: () => void;
}

type Props = OwnProps;

export const RefreshButton: React.FC<Props> = (props) => {
  const {onClick} = props;
  const [clicked, setClicked] = useState<boolean>(false);
  const intl = useIntl();

  const handleClick = (event) => {
    event.stopPropagation();
    setClicked(!clicked);
    onClick();
  };

  return (
    <Spring
      from={{rotate: 0}}
      to={{rotate: clicked ? 180 : 0}}
      config={config.gentle}
    >
      {({rotate}) => (
        <animated.button
          type={'button'}
          className={classNames({
            [styles.dlRefreshButton]: true,
            'float-end': true,
          })}
          style={{
            transform: rotate.to((r) => `rotate(${(clicked ? 1 : -1) * r}deg)`),
          }}
          title={TranslateUtils.translate(I18N.REFRESH, intl)}
          onClick={handleClick}
        >
          <i className={'fas fa-sync fa-2x'} />
        </animated.button>
      )}
    </Spring>
  );
};

RefreshButton.displayName = 'RefreshButton';
